import { render, staticRenderFns } from "./totalDiscount.vue?vue&type=template&id=6dec03b7&"
import script from "./totalDiscount.vue?vue&type=script&lang=js&"
export * from "./totalDiscount.vue?vue&type=script&lang=js&"
import style0 from "./totalDiscount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports